<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" title="生成专利海报(名称和时间可编辑)" :width="800">
      <!--查看详情弹出层-->
      <div class="sevecanvass">
        <div class="createdBtn">
          <p><Button type="success" icon="md-cloud-download" v-show="showPrice" @click="$refs.Osgaijia.hello('海报价格修改')">更改专利的价格</Button></p>
          <p style="margin-top: 10px"><Button type="warning" icon="md-cloud-download" @click="createdHaibao()">生成并下载海报</Button></p>
        </div>
        <div class="content" id="canvasdeteil">
          <div id="app">
            <div class="onlyBgContainer">
              <!--头部区域 开始-->
              <div class="hb_Top">
                <div class="dd1">
                  <div class="onlybg oe" contenteditable="true">{{ txt }}</div>
                </div>
                <div class="dd2">
                  <div class="onlybg oe" contenteditable="true">{{ created }}</div>
                </div>
              </div>
              <!--头部区域 结束-->

              <!--列表区域 开始-->
              <div class="hb_List1">
                <div class="banxin95 hb_List2">
                  <div class="itemlist" v-if="list200.length > 0">
                    <div class="your_topimg"><img src="./style/images/bgjiantou.png" /></div>
                    <div class="your_title">
                      <div class="onlybg bgquanbu oe">已下证</div>
                    </div>
                    <div class="your_content">
                      <div class="itemdiv" v-for="(item, index) in list200" :key="index">
                        <div class="fls">
                          <span>{{ index + 1 }}</span>
                        </div>
                        <div class="frs">
                          <div class="fr_titles">
                            <span class="tag"
                              ><font>{{ $s("zhuanKind", item.kind) }}</font></span
                            >
                            {{ item.applicationNumber }}<span v-html="item.title"></span>
                          </div>
                          <div class="fr_status">
                            <p class="pp2" v-if="!$isblank(item.keyword)" v-html="'领域：' + trimParentheses(item.keyword)"></p>
                            <p class="money" v-show="showPrice" v-if="$amount(item.NewPrice)">{{ $amount(item.NewPrice) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="itemlist" v-if="list100.length > 0">
                    <div class="your_topimg"><img src="./style/images/bgjiantou.png" /></div>
                    <div class="your_title">
                      <div class="onlybg bgquanbu oe">未下证</div>
                    </div>
                    <div class="your_content">
                      <div class="itemdiv" v-for="(item, index) in list100" :key="index">
                        <div class="fls">
                          <span>{{ index + 1 }}</span>
                        </div>
                        <div class="frs">
                          <div class="fr_titles">
                            <span class="tag"
                              ><font>{{ $s("zhuanKind", item.kind) }}</font></span
                            >
                            {{ item.applicationNumber }}<span v-html="item.title"></span>
                          </div>
                          <div class="fr_status">
                            <p class="pp2" v-if="!$isblank(item.keyword)" v-html="'领域：' + trimParentheses(item.keyword)"></p>
                            <p class="money" v-show="showPrice" v-if="$amount(item.NewPrice)">{{ $amount(item.NewPrice) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="itemlist" v-if="list300.length > 0">
                    <div class="your_topimg"><img src="./style/images/bgjiantou.png" /></div>
                    <div class="your_title">
                      <div class="onlybg bgquanbu oe">未标记</div>
                    </div>
                    <div class="your_content">
                      <div class="itemdiv" v-for="(item, index) in list300" :key="index">
                        <div class="fls">
                          <span>{{ index + 1 }}</span>
                        </div>
                        <div class="frs">
                          <div class="fr_titles">
                            <span class="tag"
                              ><font>{{ $s("zhuanKind", item.kind) }}</font></span
                            >
                            {{ item.applicationNumber }}<span v-html="item.title"></span>
                          </div>
                          <div class="fr_status">
                            <p class="pp2" v-if="!$isblank(item.keyword)" v-html="'领域：' + trimParentheses(item.keyword)"></p>
                            <p class="money" v-show="showPrice" v-if="$amount(item.NewPrice)">{{ $amount(item.NewPrice) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--列表区域 结束-->
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <Osgaijia ref="Osgaijia" @updataPrice="updataPrice"></Osgaijia>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import Osgaijia from "@/components/Osgaijia/Osgaijia";
import "./style/css.css";
export default {
  name: "Oshaibao",
  components: {
    Osgaijia,
  },
  data() {
    return {
      show: false,
      showPrice: false,
      list: "",
      txt: "",
      created: "",
      list100: "",
      list200: "",
      list300: "",
    };
  },
  props: {
    // 弹窗显示隐藏
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:生成海报预览
    // +----------------------------------------------------------------------
    createdHaibaoLook(list, showPrice, txt) {
      this.showPrice = showPrice;
      list = list.map((item) => {
        return {
          ...item, // 保留原有属性
          NewPrice: "", // 添加 NewPrice 属性
        };
      });
      this.list = list;
      this.txt = this.txt || "今日优质专利分享";
      this.created = this.$timeFmt(this.$getNowUnix(), "YYYY-MM-DD");
      //根据 type 分组
      this.list100 = list.filter((item) => item.type === 100);
      this.list200 = list.filter((item) => item.type === 200);
      this.list300 = list.filter((item) => item.type !== 100 && item.type !== 200);
      this.show = true;
      if (showPrice) {
        this.$refs.Osgaijia.hello("海报价格修改");
      }
    },

    // +----------------------------------------------------------------------
    // | Desc:生成海报
    // +----------------------------------------------------------------------
    createdHaibao() {
      //【弹出工具栏】生成海报#############################################
      html2canvas(document.querySelector("#canvasdeteil")).then((canvas) => {
        var fileName = "haibao.png";
        var content = canvas.toDataURL("image/png");
        const base64ToBlob = function (code) {
          let parts = code.split(";base64,");
          let contentType = parts[0].split(":")[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], {
            type: contentType,
          });
        };
        let aLink = document.createElement("a");
        let blob = base64ToBlob(content); //new Blob([content]);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        aLink.download = fileName;
        aLink.href = URL.createObjectURL(blob);
        aLink.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        this.$msg("海报生成成功，请在本地查看", "success");
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:去掉首尾中英文括号
    // +----------------------------------------------------------------------
    trimParentheses: function (str) {
      const regex = /^[\（\（\）\）]*(.*?)[\（\（\）\）]*$/;
      const result = str.match(regex);
      return result ? result[1] : str;
    },

    // +----------------------------------------------------------------------
    // | Desc:修改list的NewPrice价格，基价是Price
    // | Price{
    // |     "updataPriceType": "100",//100按照百分比加价,200按照价格修改加价
    // |     "updataPriceKind100": "100",//kind=100的修改数据
    // |     "updataPriceKind200": "100",//kind=200的修改数据
    // |     "updataPriceKind300": "100"//kind=300的修改数据
    // | }
    // +----------------------------------------------------------------------
    updataPrice: function (Price) {
      var list = this.list;
      for (var i = 0; i < list.length; i++) {
        //基本数据
        var item = list[i];
        var NewPrice = item.price;

        //执行改价
        if (item.price != "售价面议") {
          //修改发明专利价格
          if (item.kind == 100) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind100 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind100;
            } else if (Price.updataPriceType == 300) {
              var NewPrice = item.price;
            }
          }

          //修改新型实用专利价格
          if (item.kind == 200) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind200 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind200;
            } else if (Price.updataPriceType == 300) {
              var NewPrice = item.price;
            }
          }

          //修改外观实用专利价格
          if (item.kind == 300) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind300 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind300;
            } else if (Price.updataPriceType == 300) {
              var NewPrice = item.price;
            }
          }

          //整数化
          var NewPrice = parseInt(NewPrice);
        }

        //数据整合
        item.NewPrice = NewPrice;
        list[i] = item;
      }
      //根据 type 分组展示
      this.list100 = list.filter((item) => item.type == 100);
      this.list200 = list.filter((item) => item.type == 200);
      this.list300 = list.filter((item) => item.type != 100 && item.type != 200);
    },
  },
};
</script>
<style scoped>
.money {
  white-space: nowrap;
  margin-left: 10px;
  font-size: 18px;
  color: #19be6b !important;
}
</style>
